/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

/* External Imports */
import {
  Box,
  Center,
  CloseButton,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Link,
  useDisclosure,
} from '@chakra-ui/react';
import { refineUrlDomain } from '@shi/components/Utility/utils';
import { nanoid } from 'nanoid';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Component */
import SimpleButton from '@shi/components/button/SimpleButton';
import PricingGlobal from '@shi/section/PricingGlobal';

/* Styles */
/* Services */

/**
 *
 * @param {Object} pageData
 * @param {String} lang
 * @param {String} region
 * @returns {ReactElement} PricingPopup
 */
const OverSeasPopup = ({ btnRef, pageData, lang, region }) => {
  const [isPopup, setIsPopup] = useState(0);
  const router = useRouter();

  const { onClose } = useDisclosure();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const pricing = pageData?.body?.find(
    item => item?.sectionId === 'pricing-global'
  );

  useEffect(() => {
    // console.log(pricing, router?.asPath, router?.query, 'ispopup111');
    // setTimeout(() => {
    if (router?.asPath?.indexOf('overseas-popup') > -1) {
      setIsPopup(1);
      console.log(pricing, isPopup, 'ispopup222');
    } else {
      setIsPopup(0);
    }
    // }, [1500]);
    // }
    // console.log(isPopup, 'ispopup');
  }, [router?.asPath]);

  // console.log(pricing, isPopup, router?.asPath, 'ispopup000');
  // const { returnHref } = useContextualRouting();
  return (
    pricing !== undefined && (
      <Drawer
        // isOpen={isPopup}
        isOpen={isPopup}
        placement={isMobile ? 'bottom' : 'center'}
        onClose={() => {
          router.push(
            refineUrlDomain(
              `/shivanga/${region}/${lang}/sadhana`,
              region,
              lang
            ),
            {
              shallow: true,
            }
          );
        }}
        // finalFocusRef={btnRef}
        size={'full'}
      >
        <DrawerOverlay />
        <DrawerContent
          background={{ base: '#02093C', md: 'transparent' }}
          height={{ base: '81dvh', md: '100dvh' }}
          mt="auto"
          borderRadius={{ base: '6px 6px 0px 0px', md: 'none' }}
          // maxW={{ md: 785 }}
          // mx={{ md: 'auto' }}
          // transform={{ md: 'translate(-50%, -50%) !important' }}
          // top={{ md: '50% !important' }}
          // left={{ md: '50% !important' }}
        >
          <NextLink
            href={refineUrlDomain(
              `/shivanga/${region}/${lang}/sadhana`,
              region,
              lang
            )}
            passHref
            legacyBehavior
            shallow
            scroll={false}
          >
            <DrawerCloseButton
              as={Link}
              _focusVisible={{ boxShadow: 'none' }}
              // onClick={() =>
              //   router.push(`${router.asPath.split('?')[0]}?popup=0`)
              // }
              // href={`${router.asPath.split('?')[0]}?popup=0`}
              color="#fff"
              mr="15px"
              fontWeight="bold"
              fontSize="16px"
              mt="15px"
              display={{ base: 'block', md: 'none' }}
            />
          </NextLink>
          <DrawerHeader py="7.5px" as="box" h="50px">
            <p></p>
          </DrawerHeader>
          <DrawerBody
            display="flex"
            justifyContent="center"
            alignItems="center"
            pt={{ base: '50px', md: '0px' }}
            maxW={785}
            width="100%"
            mx="auto"
          >
            <Box
              maxW="1112px"
              mx="auto"
              width="100%"
              background="#02093C"
              pos="relative"
              maxH="100%"
              overflowY="auto"
              px="16px"
              py={{ base: 'none', md: '30px' }}
            >
              <NextLink
                href={refineUrlDomain(
                  `/shivanga/${region}/${lang}/sadhana`,
                  region,
                  lang
                )}
                shallow
                scroll={false}
                passHref
                legacyBehavior
              >
                <CloseButton
                  as={Link}
                  // href={`${router.asPath.split('?')[0]}?popup=0`}
                  _focusVisible={{ boxShadow: 'none' }}
                  pos="absolute"
                  right={{ base: '0', md: '10px' }}
                  display={{ base: 'none', md: 'flex' }}
                  top="10px"
                  color="#fff"
                  // onClick={() =>
                  //   router.push(`${router.asPath.split('?')[0]}?popup=0`)
                  // }
                />
              </NextLink>
              <PricingGlobal
                sectionContent={pricing?.sectionContent}
                lang={lang}
                region={region}
                isInPopup
              />
            </Box>
          </DrawerBody>

          <DrawerFooter
            display={{ base: 'block', md: 'none' }}
            as="div"
            bg="#00052F"
          >
            <Center>
              {pricing.sectionContent?.map((secCon, index) => {
                if (secCon._modelApiKey === 'simple_button') {
                  return (
                    <SimpleButton
                      fontSize="16px"
                      style={secCon}
                      minW="243px"
                      mb="0"
                      key={nanoid()}
                      mt="5px"
                    />
                  );
                }
              })}
            </Center>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    )
  );
};

export default OverSeasPopup;
